import React, { Component } from 'react';

import './Ball.css'

class Ball extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showCurrVector: false,
      showAccVector: false,
      showNoCollisionTime: true,
      showName: this.props.fullRanking,
      backgroundColor: "rgba(20, 0, 225, 0.2)",
      currentUserBackgroundColor: "rgba(20, 0, 225, 0.5)",
      highScoreShadow: "0 0 10px #00ffec",
      highScoreTimeColor: "#00ffec",
      highScoreNameColor: "#00ffec",
      zenMode: this.props.zenMode, // Draw a semi transparent square behind the ball (if ball is a zen ball)
      maxZenAngleStep: 0.5, // Throttle the rotation to be more "zen"
      dynamicSquareSize: this.props.zenSettings.dynamicSquareSize, // animate the size of the squares based on current max no collision time
      initialZenSize: window.screen.height/100*70, // px (70% of screen width)
      minZenSize: window.screen.height/100*10 //px (10% of screen width)
    };

    this.currentZenAngle = this.props.ball.angle

  }

  _currentZenSize = () => {    
    const newZenSize = this.state.initialZenSize*Math.exp(-this.props.currentHighScoreSec/40)
    return newZenSize < this.state.minZenSize ? this.state.minZenSize : newZenSize
  }

  componentDidUpdate(prevProps) {
    if (this.props.fullRanking !== prevProps.fullRanking) {
      this.setState({
        showName: this.props.fullRanking
      })
    }
    
    if (this.props.zenMode !== prevProps.zenMode || this.props.zenSettings.dynamicSquareSize !== prevProps.zenSettings.dynamicSquareSize) {
      this.setState({
        zenMode: this.props.zenMode,
        dynamicSquareSize: this.props.zenSettings.dynamicSquareSize
      })
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    // Only update if position, angle, or visual properties actually changed
    return nextProps.ball.x !== this.props.ball.x ||
      nextProps.ball.y !== this.props.ball.y ||
      nextProps.ball.angle !== this.props.ball.angle ||
      nextProps.ball.noCollisionTime !== this.props.ball.noCollisionTime ||
      nextProps.currentBall !== this.props.currentBall ||
      nextProps.hasHighScore !== this.props.hasHighScore ||
      nextProps.fullRanking !== this.props.fullRanking ||
      nextProps.zenMode !== this.props.zenMode ||
      nextProps.currentHighScoreSec !== this.props.currentHighScoreSec ||
      nextProps.zenSettings.dynamicSquareSize !== this.props.zenSettings.dynamicSquareSize
  }

  render() {

    const ball = this.props.ball
    const scaling = this.props.scaling.x // currently, I keep the aspect ratio constant, so x and y scaling are equal

    const radius = ball.radius * scaling || 50 * scaling

    const userBall = typeof ball.id === "string"
    const backgroundColor = this.props.currentBall ? this.state.currentUserBackgroundColor : userBall ? this.state.backgroundColor : false
    const boxShadow = this.props.hasHighScore ? this.state.highScoreShadow : false
    const timeColor = this.props.hasHighScore ? this.state.highScoreTimeColor : false
    const nameColor = this.props.hasHighScore ? this.state.highScoreNameColor : false

    const ballStyle = {
      height: radius * 2,
      width: radius * 2,
      left: ball.x * scaling - radius,
      top: ball.y * scaling - radius,
      backgroundColor: backgroundColor,
      boxShadow
    }
    const timeStyle = {
      color: timeColor
    }
    const nameStyle = {
      color: nameColor
    }

    let xVector
    let yVector
    if (this.state.showCurrVector) {
      xVector = radius + radius * Math.cos(ball.angle * Math.PI / 180)
      yVector = radius + radius * Math.sin(ball.angle * Math.PI / 180)
    }

    let xAccVector
    let yAccVector
    if (this.state.showAccVector) {
      xAccVector = radius + radius * Math.cos(ball.accAngle * Math.PI / 180)
      yAccVector = radius + radius * Math.sin(ball.accAngle * Math.PI / 180)
    }

    let currentZenSize = this.state.initialZenSize
    if(this.state.zenMode){
      const currentAngleDiff = this.currentZenAngle - ball.angle
      if(Math.abs(currentAngleDiff) < this.state.maxZenAngleStep){
        // the difference is within the max Angle, apply it
        this.currentZenAngle = ball.angle
      }else{
        // calculate the next current zen angle based on maxZen step (TODO? fix problem when passing 365 or 0 degrees)
        this.currentZenAngle += (this.currentZenAngle < ball.angle ? this.state.maxZenAngleStep : -this.state.maxZenAngleStep)%360
      }
      if(this.state.dynamicSquareSize){
        currentZenSize = this._currentZenSize()
      }
    }

    return (
      <div className="ball" style={ballStyle}>
        {
          this.state.showNoCollisionTime &&
          <div className="ball-time-wrapper">
            <div className="ball-time" style={timeStyle}>
              {Math.floor(ball.noCollisionTime / 1000)}
            </div>
          </div>
        }
        {
          this.state.showName &&
          <div className="ball-name" style={nameStyle}>
            {ball.player.name}
          </div>
        }
        {
          this.state.showCurrVector &&
          <svg height={radius * 2} width={radius * 2} className="ball-vector">
            <line x1={radius} y1={radius} x2={xVector} y2={yVector} style={{ stroke: "red", strokeWidth: 2 }} />
          </svg>
        }
        {
          this.state.showAccVector &&
          <svg height={radius * 2} width={radius * 2} className="ball-vector">
            <line x1={radius} y1={radius} x2={xAccVector} y2={yAccVector} style={{ stroke: "green", strokeWidth: 2 }} />
          </svg>
        }
        {
          this.state.zenMode &&
          <div className="ball-zen" style={{ 
            transform: `rotate(${this.currentZenAngle}deg)`, 
            width: `${currentZenSize}px`,
            height: `${currentZenSize}px`,
            left: `-${currentZenSize/2-radius}px`,
            top: `-${currentZenSize/2-radius}px`
          }}></div>
        }
      </div>
    );
  }
}

export default React.memo(Ball);